import { GDPRCookie } from '@wkda/gdprlib';
export async function isGdprCookiePermited(env, cookieService, name) {
  const isProduction = env === 'prod' || env === 'preprod';
  const gdprCookieService = await GDPRCookie.init(cookieService.getAll(), cookieService, isProduction);
  return gdprCookieService.isPermitted(name);
}